const locale = {
	welcome: 'ようこそ!',
    login_into_your_account: 'アカウントにログインします',
    email:'メールアドレス',
    password:'パスワード',
    forgot_password:'パスワードをお忘れですか',
    login: 'ログイン',
    need_an_account:'SCAIは初めてご利用ですか？',
    sign_up_now: 'SCAIアカウントを作成する!',
    account_not_activated: 'Account is not activated',

    set_new_password: '新しいパスワードを設定する',
    reset_your_password:'パスワードをリセットしてください。',
    enter_your_previously_email_registered:'以前にご登録いただいたメールアドレスを入力してください。',
    a_generated_code_will_be_send_to_your_email:'生成されたコードがメールに送信されます。',
    send_reset_link:'メールを送る',
    go_back_to_login_page: 'ログインページに戻ってください',
    password_requirements:'パスワードには、大文字、小文字、数字、特殊文字、および8文字以上を含める必要があります.',
    password_confirm:'新しいパスワードを確認',
    resend_verification_email:'Resend verification email',
    back_to_login:'Back to login page',
    processing_resend_email:'Our system is currently sending you an email to allow you to activate your account',
    resend_verify_email_success:'Email sent with success',
    resend_verify_email_error:'Error : Email has not been sent. Please contact administrator',
    password_updated_success:'Password has been updated with success. Redirecting to login page.',
    password_updated_error:'Error : Password has not been updated. Please contact administrator',
    forgot_password_email_sent:'Email sent with success',
    processing_reset_password_email:'Our system is currently sending you an email to allow you to reset your password',
    error_when_send_email:'Error : Email has not been sent, please verify your account',


    register: '登録',
    name: '名前',
    enter_name:'名前',
    email_id:'メールアドレス',
    enter_email: 'メールアドレス',
    affiliation: '本支店・現場',
    select_affiliation: '本支店・現場',
    head_office: '本社',
    branch_office: '支店',
    site_office: '現場',
    position: '役職',
    select_position: '役職',
    統括所長:'統括所長',
    project_manager:'プロジェクトマネージャ',
    副所長1:'副所長1',
    課長1_現場: '課長1 (現場)',
    副所長2:'副所長2',
    課長_現場:'課長 (現場)',
    主任1_現場: '主任1 (現場)',
    主任2_現場: '主任2 (現場)',
    係_現場:'係 (現場)',
    支店_Branch: '支店 (Branch)',
    Other:'Other',
    group_type:'所属',
    new_password:'新しいパスワード',
    enter_password:'新しいパスワード',
    confirm_new_password: '新しいパスワードを確認',
    submit:'登録',
    already_have_an_account: 'すでにアカウントをお持ちですか?',
    sign_in: 'サインイン',

    please_reset_your_password:'パスワードをリセットしてください',
    please_insert_the_one_time_password_you_sent_by_email:'メールでお送りした ワンタイムパスワード を挿入してください',
    password_reset_if_you_do_not_receive_an_email_with_a_one_time_password_immediately_check_your_junk_email_folder: 'パスワードリセットワンタイムパスワードが記載されたメールがすぐに届かない場合は、迷惑メールフォルダを確認してください',
    one_time_password: 'ワンタイムパスワード',
    response_one_time_password_otp: '応答ワンタイムパスワード[OTP]',
    please_return_to_login_page:'ログインページに戻ってください',
    something_went_wrong: 'エラー!',
    update_succesfully: '更新完了!',
};

export default locale;
